<template>
    <div class="tabletDebug">
        <div class="debugPos">
            scale: {{scale}},
            offset: {{offset.x | round}} {{offset.y | round}}
        </div>

    </div>
</template>

<script>
  export default {
    name: "TabletDebug",
    computed: {
      offset() {
        return this.$store.state.canvas.offset;
      },
      scale() {
        return this.$store.state.canvas.scale;
      }
    }
  }
</script>

<style scoped lang="sass">
@import "../../sass/zindex"
@import "../../sass/common"
.tabletDebug
    z-index: $z_debug

    position: absolute

</style>
